import styled from 'styled-components'

const PageTitle = styled.h4`
  margin-top: 10px;
`

export default PageTitle
